<script>
export default {
    name: 'OneMurtfeldtNotification',
    methods: {
        closeAndRedirect() {
            this.$emit('close');
            this.$router.push('/zusammen-wachsen');
        },
        close() {
            this.$emit('close');
        }
    },
};
</script>
<template>
    <div class="wrapper is-flex is-flex-direction-column is-align-items-center">
        <div class="container">
            <div class="text-container">
                <p class="has-text-weight-bold mb-3">
                    {{ $t('oneMurtfeldtNotification.header') }}
                </p>
                <p class="has-text-weight-bold is-size-4">
                    {{ $t('oneMurtfeldtNotification.subHeaderOne') }}
                </p>
                <p class="has-text-weight-bold is-size-4">
                    {{ $t('oneMurtfeldtNotification.subHeaderTwo') }}
                </p>
                <p class="mb-3">
                    {{ $t('oneMurtfeldtNotification.firstParagraph') }}
                </p>
                <p class="mb-3">
                    {{ $t('oneMurtfeldtNotification.secondParagraph') }}
                </p>
                <p class="mb-3">
                    {{ $t('oneMurtfeldtNotification.thirdParagraph') }}
                </p>
                <p class="is-size-4 is-size-5-mobile has-text-weight-bold mb-4">
                </p>
            </div>
            <b-button class="mb-3" @click="closeAndRedirect">
                {{ $t('oneMurtfeldtNotification.button.text') }}
            </b-button>
            <b-button class="mb-3" @click="close">
                {{ $t('oneMurtfeldtNotification.button.text_back') }}
            </b-button>
        </div>
    </div>
</template>

<style lang="css" scoped>
.wrapper {
    width: 100%;
}

.container {
    padding-top: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 800px !important;
    background-color: #FFF;
}
.modal-background {
    background-color: teal!important;
}

.text-container {
    padding: 0 4rem;
}

</style>
